<div class="cards">
  <ui-card-front-display [background]="'bg-amex'">
    <div class="amex-card-front">
      <div class="card-info">
        <img class="arrow" src="../../../../../assets/svg/amex-logo.svg" alt="">
        <div class="card-chip">
          <img class="arrow" src="../../../../../assets/svg/arrow_left.svg" alt="">
          <img class="card-chip-img" src="../../../../../assets/svg/credit-card-chip.svg" alt="">
        </div>
      </div>
      <div class="card-data">
        <p>{{cardNumber}}</p>
        <p>{{expirationDate.length > 1 ? expirationDate : 'MM/YY'}}</p>
        <p style="overflow: hidden;">{{cardName.length > 0 ? cardName : 'NOMBRE Y APELLIDO'}}</p>
        <div class="card-data-info">
          <img src="../../../../../assets/card-logotipe/amex.svg" alt="">
        </div>
      </div>
    </div>
  </ui-card-front-display>
  <ui-card-back-display [cvv]="cvv" [background]="'bg-amex'">
    <div class="amex-card-back">
      <div class="card-chip"></div>
      <div class="card-data">
        <div class="card-data-info"></div>
        <div class="cvv">
          <p>{{cvv}}</p>
        </div>
      </div>
    </div>
  </ui-card-back-display>
</div>
